import { useEffect, useState } from "react";
import axios from "axios";
import { WifiMark } from "@/components/WifiMark";
import { LoginForm } from "@/components/admin/LoginForm";
import { ProductsTab } from "@/components/admin/ProductsTab";
import { ContentTab } from "@/components/admin/ContentTab";
import { SubscribersTab } from "@/components/admin/SubscribersTab";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "offline_admin_token";

const TABS = [
    ["products", "Products"],
    ["content", "Page Content"],
    ["subscribers", "Blacklist"],
];

export default function Admin() {
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
    const [tab, setTab] = useState("products");

    useEffect(() => {
        if (!token) return;
        axios
            .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
            .catch(() => {
                localStorage.removeItem(TOKEN_KEY);
                setToken(null);
            });
    }, [token]);

    const onLogin = (t) => {
        localStorage.setItem(TOKEN_KEY, t);
        setToken(t);
    };
    const onLogout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setToken(null);
    };

    return (
        <div className="min-h-screen bg-void text-white font-sans" data-testid="admin-page">
            <div className="grain-overlay" aria-hidden="true" />
            <header className="flex items-center justify-between px-6 sm:px-10 py-5 border-b border-zinc-800">
                <a href="/" className="flex items-baseline font-display font-semibold text-lg tracking-tight" data-testid="admin-logo">
                    <WifiMark className="h-4 w-auto self-center" pulsing={false} />
                    FFLINE
                    <span className="ml-3 text-[10px] tracking-[0.3em] uppercase text-zinc-500">Studio</span>
                </a>
                {token && (
                    <button
                        onClick={onLogout}
                        data-testid="admin-logout-button"
                        className="text-[10px] tracking-[0.25em] uppercase text-zinc-400 hover:text-signal transition-colors duration-300"
                    >
                        Log out
                    </button>
                )}
            </header>

            {!token ? (
                <LoginForm onLogin={onLogin} />
            ) : (
                <main className="px-6 sm:px-10 py-10 max-w-5xl mx-auto">
                    <div className="flex gap-8 mb-10 border-b border-zinc-800" data-testid="admin-tabs">
                        {TABS.map(([k, l]) => (
                            <button
                                key={k}
                                onClick={() => setTab(k)}
                                data-testid={`admin-tab-${k}`}
                                className={`pb-3 -mb-px text-[11px] tracking-[0.25em] uppercase transition-colors duration-300 ${
                                    tab === k ? "text-white border-b border-signal" : "text-zinc-500 hover:text-zinc-300"
                                }`}
                            >
                                {l}
                            </button>
                        ))}
                    </div>
                    {tab === "products" && <ProductsTab token={token} />}
                    {tab === "content" && <ContentTab token={token} />}
                    {tab === "subscribers" && <SubscribersTab token={token} />}
                </main>
            )}
        </div>
    );
}
